// @flow
import {useDispatch} from 'react-redux'
import * as actions from '../../actions/actions'
import {useCallback, useContext} from "react";
import {getCurrentUserPermissions} from "../../modules/permission/actions/actions";
import {GLOBAL_VARS} from "../../App";
import { showPopup } from '../../../src/components/globalPopup/globalPopupService';
import { LOANS_APPLICATION } from "../../modules/loanApplication/locales/namespaces";
import { useTranslation } from "react-i18next";
import { ConfigContext } from '../../../src/theme/mantis/contexts/configContext';
import { useLocation } from "react-router-dom";

const useUserAction = () => {
	const { resetCountdownKey, onResetCountdown } = useContext(ConfigContext);
	const { t } = useTranslation(LOANS_APPLICATION)
	const location = useLocation();

	
	const dispatch = useDispatch()
	
	const checkAPIConnectivity = useCallback(() => {
		dispatch(actions.checkAPIConnectivity())
	}, [dispatch])
	
	const userLogin = useCallback((values) => {
	
		const bodyFormData = new FormData();
		bodyFormData.append('username', values.username);
		bodyFormData.append('password', values.password);
		bodyFormData.append("device_token", GLOBAL_VARS.device_token);
		dispatch(actions.userLogin(bodyFormData))
	}, [dispatch])
	
	const googleLogin = useCallback((googleApiResponse) => {
		dispatch(actions.googleLogin({
			data: googleApiResponse
		}))
	}, [dispatch])
	
	const userLogout = useCallback((e) => {
		if (GLOBAL_VARS?.hasDigitalFormChanged && location.pathname.includes("/loans/application")) {
			showPopup({
				title: '',
				message:e ? t('Warning')+': ' +t('You have unsaved changes. Are you sure you want to close the form and lose your modifications?') : t('Warning')+': ' +t('Your session has expired and you have not saved your changes. Would you like to extend your session?'),
				cancel:e? t('Cancel') : t('Extend Session'),
				ok:t('Close without saving'),
				onConfirm: () => {
					const bodyFormData = new FormData();
					bodyFormData.append("device_token", GLOBAL_VARS.device_token);
					dispatch(actions.userLogout(bodyFormData))
				},
				onCancel: () => {
					onResetCountdown();
				}
			});
			return
		}



		const bodyFormData = new FormData();
		bodyFormData.append("device_token", GLOBAL_VARS.device_token);
		dispatch(actions.userLogout(bodyFormData))
	 }, [dispatch])
	
	const setUserLanguage = useCallback((language) => {
		dispatch(actions.setUserLanguage(language))
	}, [dispatch])
	
	const setUserAlterPassword = useCallback((alterPassword) => {
		dispatch(actions.setUserAlterPassword(alterPassword))
	}, [dispatch])
	
	const getUserPermissions = useCallback(() => {
		dispatch(getCurrentUserPermissions())
	}, [dispatch])
	
	return {
		checkAPIConnectivity,
		userLogin,
		userLogout,
		setUserLanguage,
		setUserAlterPassword,
		getUserPermissions,
		googleLogin
	}
}

export default useUserAction